export function directoryInvalidProjectLinkTitle() {
  return "Project link could not be opened"
}

export function directoryInvalidProjectLinkMessage() {
  return "This project link is invalid. Open the project from Home or check the link and try again."
}
